import React, { useContext } from "react";

import styled from "@emotion/styled";

import { DataContext } from "../../../../../../providers/GasCheckoutDataProvider";
import NewHeadline from "../../../../../shared/NewHeadline";

const ZipcodeWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
`;

const StreetWrapper = styled.div`
    display: flex;
    margin-right: 10px;
    margin-left: 10px;
`;

const ZipcodeLabel = styled.div`
    display: flex;
    margin-right: 10px;
    margin-left: 10px;
`;

const ZipcodeValue = styled.div`
    display: flex;
    flex-grow: 1;
`;

const DeliveryAddress = () => {
    const dataContext = useContext(DataContext);

    const { place, street, houseNum, zipcode } = dataContext.data;

    return (
        <React.Fragment>
            <NewHeadline>Lieferadresse</NewHeadline>
            <StreetWrapper>
                {String(street.value) + " " + String(houseNum)}
            </StreetWrapper>

            <ZipcodeWrapper>
                <ZipcodeLabel>{zipcode}</ZipcodeLabel>
                <ZipcodeValue>{place.value}</ZipcodeValue>
            </ZipcodeWrapper>
        </React.Fragment>
    );
};

export default DeliveryAddress;
